import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProjectsInfo from "../projectsComponent/projectsInfo";
import data from "../../data";

const PROJECTS_PER_PAGE = 5;

function ProjectsSection({ title, items }) {
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(items.length / PROJECTS_PER_PAGE);
    const startIndex = (currentPage - 1) * PROJECTS_PER_PAGE;
    const projects = items.slice(startIndex, startIndex + PROJECTS_PER_PAGE);

    const goToPage = page => {
        setCurrentPage(page);
    }

    const goToPreviousPage = () => {
        setCurrentPage(page => Math.max(page - 1, 1));
    }

    const goToNextPage = () => {
        setCurrentPage(page => Math.min(page + 1, totalPages));
    }

    return (
        <section className="projects_content">
            <h2>{title}</h2>
            {projects.map(item => {
                return <ProjectsInfo key={item.title} {...item}/>
            })}

            {totalPages > 1 && (
                <nav className="projects_pagination" aria-label={`${title} pagination`}>
                    <button
                        type="button"
                        onClick={goToPreviousPage}
                        className="projects_pagination-arrow"
                        disabled={currentPage === 1}
                        aria-label={`Previous ${title} page`}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-chevron-left" />
                    </button>

                    <div className="projects_pagination-pages">
                        {Array.from({ length: totalPages }, (_, index) => {
                            const page = index + 1;

                            return (
                                <button
                                    type="button"
                                    key={page}
                                    onClick={() => goToPage(page)}
                                    className={currentPage === page ? "active" : ""}
                                    aria-current={currentPage === page ? "page" : undefined}
                                    aria-label={`${title} page ${page}`}
                                >
                                    {page}
                                </button>
                            )
                        })}
                    </div>

                    <button
                        type="button"
                        onClick={goToNextPage}
                        className="projects_pagination-arrow"
                        disabled={currentPage === totalPages}
                        aria-label={`Next ${title} page`}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-chevron-right" />
                    </button>
                </nav>
            )}
        </section>
    )
}

function Projects(props) {
    return (
        <main className={`projects ${props.darkMode ? "dark" : ""}` }>
            <ProjectsSection title="Company Projects" items={data.projects.content} />
            <ProjectsSection title="Personal Projects" items={data.projects.personal} />
        </main>
    )
}

export default Projects
